module.exports = __webpack_public_path__ + "img/hocr-icon.4cd68920.svg";